// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1455":"836e3014","3792":"24cd54e9","4936":"2c2e04ee","6298":"5b0832f8","6702":"24cd54e9"}[chunkId] + ".chunk.css";
};